export const EARLY_SHIFT_TOLERANCE_MS = 15 * 60000;
export const LATE_SHIFT_TOLERANCE_MS = 30 * 60000;
const PLANNED_LOOKAHEAD_MS = 24 * 60 * 60 * 1000;
function toDate(value) {
    if (!value) {
        return undefined;
    }
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? undefined : d;
}
export function deriveEffectiveTimes(scheduledFrom, scheduledTo, flightInfo, isCancelled, flightDataTimes, now = new Date()) {
    var _a, _b, _c, _d, _e, _f;
    if (isCancelled) {
        return {
            effectiveTimeOut: scheduledFrom,
            effectiveTimeIn: scheduledTo,
            phase: 'cancelled',
            flightTimeMs: scheduledTo.getTime() - scheduledFrom.getTime(),
            isShifted: false,
        };
    }
    const fplTime = toDate((_a = flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.fpl) === null || _a === void 0 ? void 0 : _a.date);
    const ctotTime = toDate((_b = flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.calculatedDeparture) === null || _b === void 0 ? void 0 : _b.date);
    const actualDeparture = (_c = toDate(flightDataTimes === null || flightDataTimes === void 0 ? void 0 : flightDataTimes.departure)) !== null && _c !== void 0 ? _c : toDate((_d = flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.actualDeparture) === null || _d === void 0 ? void 0 : _d.date);
    const actualArrival = (_e = toDate(flightDataTimes === null || flightDataTimes === void 0 ? void 0 : flightDataTimes.arrival)) !== null && _e !== void 0 ? _e : toDate((_f = flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.actualArrival) === null || _f === void 0 ? void 0 : _f.date);
    const flightTimeMs = scheduledTo.getTime() - scheduledFrom.getTime();
    let effectiveTimeOut = scheduledFrom;
    if (actualDeparture) {
        effectiveTimeOut = actualDeparture;
    }
    else if (ctotTime) {
        effectiveTimeOut = ctotTime;
    }
    else if (fplTime) {
        effectiveTimeOut = fplTime;
    }
    let effectiveTimeIn = scheduledTo;
    if (actualArrival) {
        effectiveTimeIn = actualArrival;
    }
    else if (actualDeparture || ctotTime || fplTime) {
        effectiveTimeIn = new Date(effectiveTimeOut.getTime() + flightTimeMs);
    }
    let phase = 'scheduled';
    if (actualArrival) {
        phase = 'landed';
    }
    else if (actualDeparture) {
        phase = 'inflight';
    }
    else if (ctotTime || fplTime) {
        phase = 'planned';
    }
    if (phase === 'planned' && scheduledFrom.getTime() - now.getTime() > PLANNED_LOOKAHEAD_MS) {
        effectiveTimeOut = scheduledFrom;
        effectiveTimeIn = scheduledTo;
        phase = 'scheduled';
    }
    let depShiftMs;
    if (phase === 'inflight' && actualDeparture) {
        depShiftMs = actualDeparture.getTime() - scheduledFrom.getTime();
    }
    else if (phase === 'planned') {
        const driver = ctotTime !== null && ctotTime !== void 0 ? ctotTime : fplTime;
        if (driver) {
            depShiftMs = driver.getTime() - scheduledFrom.getTime();
        }
    }
    const isDepShifted = depShiftMs !== undefined && (depShiftMs < -EARLY_SHIFT_TOLERANCE_MS || depShiftMs >= LATE_SHIFT_TOLERANCE_MS);
    const isArrShifted = (phase === 'planned' || phase === 'inflight') &&
        effectiveTimeIn.getTime() - scheduledTo.getTime() >= LATE_SHIFT_TOLERANCE_MS;
    const isShifted = isDepShifted || isArrShifted;
    return {
        effectiveTimeOut,
        effectiveTimeIn,
        phase,
        fplTime,
        ctotTime,
        actualDeparture,
        actualArrival,
        flightTimeMs,
        isShifted,
    };
}
//# sourceMappingURL=effectiveTimes.js.map